<template>
  <create-account-layout
    :current-step="3"
    title="Verification"
  >
    <form
      novalidate="novalidate"
      @submit.prevent="handleSubmit"
    >
      <div>
        <div class="flex flex-col items-start">
          <p class="flex flex-col pb-2 text-left text-sm">
            Enter the verification code sent to the selected contact method to
            continue.
          </p>
          <form-field
            id="account-verification"
            label="Verification Code"
            :value="carrier_verification_code"
            placeholder="Enter Verification Code"
            maxlength="6"
            :on-input="handleUpdate"
            name="carrier_verification_code"
            :is-valid="!error"
            error-message="Incorrect verification code"
          />
        </div>
        <button-main
          class="my-3 mb-4"
          :disabled="!carrier_verification_code"
          type="submit"
          :loading-spinner="isLoading"
          value="Verify Account"
        />
        <div class="mt-4 flex flex-col items-center">
          <p class="mb-4 text-1md text-body-color">Code didn't send?</p>
          <router-link
            to="/sign-up/fmsca-account-verification"
            class="mx-auto w-max text-1md text-yellow-500"
          >
            Try again
          </router-link>
        </div>
      </div>
    </form>
  </create-account-layout>
</template>

<script>
import CreateAccountLayout from '@/components/layouts/CreateAccountLayout.vue';
import ButtonMain from '@/components/Button.vue';
import FormField from '@/components/FormField.vue';
import { toastResponse } from '@/common/handleServerResponse';

export default {
  name: 'AccountVerification',
  components: {
    CreateAccountLayout,
    ButtonMain,
    FormField,
  },
  data() {
    return {
      isLoading: false,
      carrier_verification_code: '',
    };
  },
  created() {
    if (!this.$store.state.carriers?.carrierVerification?.id) {
      /*
       * Do not allow the user to enter the code without first registering
       * an email address and user name .
       * Warning: should happen only when the page is refreshed
       */
      this.$router.push({
        name: 'GeneralInformation',
      });
    }
  },
  async mounted() {
    const findInput = document.querySelector('#account-verification');
    await this.$store.dispatch('users/refreshCurrentUser');
    let currentUser = this.$store.state.users.currentUser;
    // Redirect if the user is already associated with a company
    if (currentUser?.company?.carrier_id) {
      this.$router.push({ name: 'Home' });
    }
    setTimeout(() => {
      findInput.focus();
    }, 0);
  },
  methods: {
    handleUpdate(e) {
      this.carrier_verification_code = e.target.value;
      this.$store.commit('updateSignupField', {
        name: 'carrier_verification_code',
        value: e.target.value,
      });
    },
    async handleSubmit() {
      this.isLoading = true;
      try {
        const res = await this.$store.dispatch(
          'carriers/carrierVerificationCode',
          {
            code: this.carrier_verification_code,
            verification_id: this.$store.state.carriers.carrierVerification.id,
          }
        );
        if ([200, 201].includes(res.status)) {
          // Force the user to refresh because we now are associated
          // with a company
          await this.$store.dispatch('users/serverRefreshCurrentUser');
          this.validation_error = false;
          let redirectAfterSignIn = JSON.parse(
            localStorage.getItem('redirect_url_after_sigin')
          );

          // If they came in through the OAuth process,
          // then then they will be redirected to the /oauth/authorizations
          // endpoint with the correct credentials
          console.log('account verification complete');
          if (redirectAfterSignIn) {
            console.log(
              'redirect_url_after_sigin present',
              redirectAfterSignIn
            );
            if (this.$store.getters['users/hasConsentedToLegalAgreements']) {
              localStorage.removeItem('redirect_url_after_sigin');
            }
            return this.$router.push(redirectAfterSignIn);
          } else {
            console.log('redirect_url_after_sigin NOT present');
            let companyType =
              this.$store.state.users.currentUser.company.company_type;

            switch (companyType) {
              case 'broker':
                return this.$router.push({ name: 'Broker Dashboard' });
              case 'carrier':
                return this.$router.push({ name: 'CarrierWelcomePage' });
              case 'dispatcher':
                return this.$router.push({ name: 'Dispatcher Dashboard' });
              default:
                return this.$router.push({ name: 'Home' });
            }
          }
        } else {
          this.validation_error = true;
          toastResponse(this, res, null);
        }
      } catch (error) {
        console.log('ERROR: ', error);
        throw error;
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>
